import { memo } from 'react';
import usePermission from './usePermission';

const PermissionGate = memo(({ allow, children, fallback = null }) => {
  return usePermission(allow) ? children : fallback;
});

export default PermissionGate;
